<script setup lang="ts">
definePageMeta({
  layout: false,
});

usePageTitle("Политика конфиденциальности");

const originalPolicyUrl = "https://disk.360.yandex.ru/i/3PRPiMGTRtzHwA";

const policySections = [
  {
    title: "1. Общие положения",
    paragraphs: [
      "1.1. Настоящая Политика (далее - «Политика») разработана Обществом с ограниченной ответственностью «Агропромшина» (ОГРН 1157746073968, ИНН 773444873, юридический адрес: 119021, г. Москва, вн. тер. г. муниципальный округ Хамовники, ул. Льва Толстого, д. 5, стр. 2) (далее - «Оператор») в соответствии с Федеральным законом от 27.07.2006 N 152-ФЗ «О персональных данных» и определяет порядок обработки и защиты персональных данных пользователей сайта https://b2b.agropromshina.ru/ (далее - «Сайт»).",
      "1.2. Политика опубликована в свободном доступе на Сайте по адресу: https://b2b.agropromshina.ru/policy.",
      "1.3. Правовые основания обработки персональных данных:",
    ],
    list: [
      "Отдельное согласие субъекта персональных данных, предоставляемое путем проставления отметки (чекбокса) на Сайте (ч. 1 ст. 9 Федерального закона N 152-ФЗ).",
      "Обработка персональных данных осуществляется в связи с регистрацией представителей юридических лиц и индивидуальных предпринимателей в B2B-системе «Partner» и последующим взаимодействием в рамках коммерческой деятельности (п. 5 ч. 1 ст. 6 152-ФЗ - в целях исполнения договора, стороной которого является контрагент).",
      "Требования законодательства Российской Федерации.",
    ],
    afterList: [
      "1.4. Настоящая Политика не является согласием на обработку персональных данных. Согласие оформляется отдельным документом (через чекбокс на Сайте) и не может быть заменено ознакомлением с Политикой.",
    ],
  },
  {
    title: "2. Состав обрабатываемых персональных данных",
    paragraphs: [
      "2.1. Оператор обрабатывает следующие персональные данные представителей контрагентов (юридических лиц и индивидуальных предпринимателей), регистрирующихся на Сайте:",
    ],
    list: [
      "Фамилия, имя, отчество;",
      "Наименование юридического лица или фамилия, имя, отчество индивидуального предпринимателя;",
      "ИНН (юридического лица или ИП);",
      "Должность представителя;",
      "Номер контактного телефона;",
      "Адрес электронной почты (e-mail).",
    ],
    afterList: [
      "2.2. Технические данные, автоматически собираемые на Сайте: IP-адрес, информация о браузере, данные об использовании Сайта (обезличенные).",
    ],
  },
  {
    title: "3. Цели обработки персональных данных",
    paragraphs: [
      "3.1. Оператор обрабатывает персональные данные для следующих целей:",
    ],
    list: [
      "Регистрация и идентификация представителей контрагентов в B2B-системе «Partner»;",
      "Оформление заказов на товары, заключение и исполнение договоров поставки с юридическими лицами и ИП;",
      "Формирование маркетинговых предложений;",
      "Обеспечение доставки товаров через транспортные компании и курьерские службы;",
      "Обработка запросов, обращений и претензий;",
      "Ведение бухгалтерского и налогового учета взаиморасчетов с контрагентами;",
      "Проведение статистических исследований для улучшения сервиса Компании.",
    ],
  },
  {
    title: "4. Способы, сроки и место хранения персональных данных",
    paragraphs: [
      "4.1. Обработка персональных данных осуществляется как с использованием средств автоматизации (электронные базы данных, серверы), так и без их использования (бумажные носители).",
      "4.2. Место хранения: В соответствии с ч. 5 ст. 18 Федерального закона N 152-ФЗ, запись, систематизация, накопление, хранение персональных данных граждан Российской Федерации осуществляются исключительно с использованием баз данных, находящихся на территории Российской Федерации. Серверное оборудование Оператора расположено на территории РФ.",
      "4.3. Сроки хранения:",
    ],
    list: [
      "Персональные данные обрабатываются в течение срока действия договорных отношений с контрагентом либо до отзыва согласия представителем.",
      "После прекращения договорных отношений или отзыва согласия данные подлежат уничтожению в течение 30 дней (ст. 21 152-ФЗ), за исключением случаев, когда законодательство (например, ст. 23 НК РФ) требует их хранения в течение определенного срока (до 5 лет для документов бухгалтерского и налогового учета).",
    ],
    afterList: [
      "4.4. Оператор заключает договор поручения со сторонней организацией (обработчиком), которая обеспечивает хранение и техническую защиту персональных данных. Обработчик обязан соблюдать требования Федерального закона N 152-ФЗ, обеспечивать локализацию баз данных на территории Российской Федерации, а также принимать следующие меры защиты: шифрование баз данных (AES-256); антивирусную защиту; межсетевой экран; разграничение доступа; журналирование действий; резервное копирование; контроль физического доступа к серверному оборудованию. Оператор осуществляет контроль за соблюдением обработчиком указанных требований.",
    ],
  },
  {
    title: "5. Передача персональных данных третьим лицам",
    paragraphs: [
      "5.1. Оператор передает персональные данные третьим лицам в следующих случаях:",
    ],
    list: [
      "Партнерам-перевозчикам (транспортным компаниям, курьерским службам): передаются фамилия, имя, отчество представителя контрагента, контактный телефон, адрес доставки (если требуется). Передача осуществляется на основании договора поручения, обязывающего перевозчика соблюдать конфиденциальность.",
      "Обработчикам (ИТ-подрядчикам, облачным провайдерам): на основании договора поручения;",
      "Государственным органам: в случаях, прямо предусмотренных законодательством РФ.",
    ],
    afterList: [
      "5.2. Трансграничная передача персональных данных Оператором не осуществляется.",
    ],
  },
  {
    title: "6. Права субъекта персональных данных",
    paragraphs: ["6.1. Субъект персональных данных имеет право:"],
    list: [
      "На получение информации, касающейся обработки его персональных данных (ст. 14 152-ФЗ);",
      "На уточнение, блокирование или уничтожение своих персональных данных в случае их недостоверности или незаконного получения;",
      "На отзыв согласия на обработку персональных данных в любое время (ст. 9 152-ФЗ);",
      "На обжалование действий Оператора в уполномоченный орган (Роскомнадзор) или в суд.",
    ],
  },
  {
    title: "7. Порядок отзыва согласия на обработку персональных данных",
    paragraphs: [
      "7.1. Субъект данных вправе в любое время отозвать согласие, направив письменное уведомление на адрес электронной почты: pd@agropromshina.ru или почтовым отправлением по юридическому адресу: 119021, г. Москва, ул. Льва Толстого, д. 5, стр. 2.",
      "7.2. С момента получения уведомления Оператор прекращает обработку персональных данных и обеспечивает их уничтожение в течение 30 дней, если иное не предусмотрено законодательством (ст. 21 152-ФЗ).",
      "7.3. Отзыв согласия может повлечь невозможность использования Сайта, доступа к B2B-системе «Partner» и получения услуг Оператора.",
    ],
  },
  {
    title: "8. Контактная информация Оператора",
    paragraphs: [
      "ООО «Агропромшина»",
      "ИНН 773444873, ОГРН 1157746073968",
      "Юридический адрес: 119021, г. Москва, ул. Льва Толстого, д. 5, стр. 2",
      "E-mail для обращений по персональным данным: pd@agropromshina.ru",
      "Телефон: +7(499)403 39 06",
      "Лицо, ответственное за организацию обработки персональных данных: Федотова Екатерина Сергеевна.",
    ],
  },
  {
    title: "9. Заключительные положения",
    paragraphs: [
      "9.1. Настоящая Политика регулируется законодательством Российской Федерации.",
      "9.2. Оператор оставляет за собой право вносить изменения в Политику. Новая редакция вступает в силу с момента ее размещения на Сайте.",
      "Дата последнего обновления: «30» мая 2026 г.",
    ],
  },
];
</script>

<template>
  <main
    class="min-h-screen bg-white px-4 py-5 text-left text-gray-dark sm:px-8 sm:py-8 lg:px-14 lg:py-10"
  >
    <article class="flex w-full max-w-[1180px] flex-col gap-6">
      <div class="flex justify-start">
        <a
          :href="originalPolicyUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex min-h-10 items-center justify-center rounded-full border border-orange px-4 py-2 text-center text-[14px] leading-[18px] font-helvetica-700 text-orange transition-colors hover:bg-orange hover:text-white"
        >
          Открыть оригинальный PDF
        </a>
      </div>

      <header class="flex flex-col gap-3 border-b border-gray-border pb-5">
        <p
          class="text-[13px] leading-[18px] font-helvetica-400 text-extra-text-color"
        >
          Утверждено приказом Генерального директора ООО «Агропромшина»
        </p>
        <h1
          class="text-[28px] leading-[1.08] font-helvetica-700 text-gray-dark sm:text-[36px] lg:text-[42px]"
        >
          Политика конфиденциальности и обработки персональных данных
        </h1>
      </header>

      <div class="flex flex-col gap-6">
        <section
          v-for="section in policySections"
          :key="section.title"
          class="flex flex-col gap-3"
        >
          <h2
            class="text-[20px] leading-[1.2] font-helvetica-700 text-gray-dark sm:text-[24px]"
          >
            {{ section.title }}
          </h2>

          <p
            v-for="paragraph in section.paragraphs"
            :key="paragraph"
            class="text-[15px] leading-[23px] font-helvetica-400 text-gray-dark sm:text-[16px] sm:leading-[25px]"
          >
            {{ paragraph }}
          </p>

          <ul
            v-if="section.list?.length"
            class="flex list-disc flex-col gap-2 pl-5 text-[15px] leading-[23px] font-helvetica-400 text-gray-dark sm:text-[16px] sm:leading-[25px]"
          >
            <li v-for="item in section.list" :key="item">
              {{ item }}
            </li>
          </ul>

          <p
            v-for="paragraph in section.afterList"
            :key="paragraph"
            class="text-[15px] leading-[23px] font-helvetica-400 text-gray-dark sm:text-[16px] sm:leading-[25px]"
          >
            {{ paragraph }}
          </p>
        </section>
      </div>
    </article>
  </main>
</template>
